export const validateSaleSupportReason = (reason: string): string | null => {
  const clean = reason.trim();
  if (!clean) return 'La razón es obligatoria.';
  if (clean.length > 500) return 'La razón no puede exceder 500 caracteres.';
  return null;
};
